module.exports = __webpack_public_path__ + "static/media/img_3-15b.a75ce709.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/img_3-15b.png
// module id = 680
// module chunks = 0